import {
  LICENSES_WITH_ORDER_FLOW,
  ORDER_FLOW_ROUTES,
} from "commonComponents/LeftMenu/menuItemsData";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

function useSalesFlow() {
  const userData = useSelector((state: any) => state.businessStore.userData),
    isOffline = useSelector((state: any) => state.businessStore.isOffline);
  const { pathname: currentPath } = useLocation();
  const isOrderFlowPath = useMemo(() => {
    // Indicates whether the current route is part of the order flow process
    return ORDER_FLOW_ROUTES.includes(currentPath);
  }, [currentPath]);
  const hasOrderFlowLicense = useMemo(() => {
    // Indicates whether the user's assigned license type supports the order flow
    return (
      LICENSES_WITH_ORDER_FLOW.includes(userData?.assignedLicence) || isOffline
    );
  }, [isOffline, userData?.assignedLicence]);

  return {
    isOrderFlowPath,
    hasOrderFlowLicense,
  };
}

export default useSalesFlow;
